<template>
  <div class="achievement-wrapper">
    <div class="nav-box">
      <div class="nav-item" :class="{'active': currentPage == 0}" @click="switchPage(0)">经验弹</div>
      <div class="nav-item" :class="{'active': currentPage == 1}" @click="switchPage(1)">设计室作品</div>
      <div class="nav-item" :class="{'active': currentPage == 2}" @click="switchPage(2)">优秀毕业生</div>
      <div class="nav-item" :class="{'active': currentPage == 3}" @click="switchPage(3)">学术出版</div>
      <span class="active-line" :style="{left: navLeft + 'px'}"></span>
    </div>
    <div class="achievement-main" id="listSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="list-wrapper">
            <div class="exp-list">
              <div class="exp-item" v-for="item in expArticleList" :key="item.id" @click="toDetail(1, item.id)">
                <div class="info">
                  <div class="title">{{item.title}}</div>
                  <div class="student">
                    <div class="logo"><img :src="item.logo" alt=""></div>
                    <div class="student-info">
                      <div class="name">{{item.name}}</div>
                      <div class="school">{{item.school_goto}} | {{item.school_major}}</div>
                    </div>
                  </div>
                </div>
                <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
              </div>
              <div class="no-more">- 没有更多了喔 -</div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="list-wrapper">
            <div class="studio-list">
              <div class="studio-item" v-for="item in studioList" :key="item.id" @click="toDetail(2, item.id)">
                <div class="info">
                  <div class="title">{{item.title}}</div>
                  <div class="sub-info">指导老师：{{item.teacher_name}}</div>
                  <div class="sub-info">{{item.major}}</div>
                </div>
                <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
              </div>
              <div class="no-more">- 没有更多了喔 -</div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="list-wrapper">
            <div class="graduate-list">
              <div class="graduate-item" v-for="item in graduateList" :key="item.id" @click="toDetail(3, item.id)">
                <div class="student">
                  <div class="school-logo"><img :src="item.logo" alt=""></div>
                  <div class="info">
                    <div class="name">{{item.showname}}</div>
                    <div class="offer-school">{{item.school_goto}} | {{item.school_major}}</div>
                    <div class="other-school">其他offer：{{item.offerString}}</div>
                  </div>
                </div>
                <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
              </div>
              <div class="no-more">- 没有更多了喔 -</div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="book-wrapper">
            <div class="book-container">
              <div class="book-banner" @click="buyBook"><img src="/Application/Home/Resource/static/images/mobile//book-banner.jpg" alt=""></div>
              <div class="book-section">
                <div class="book-title">挑战对于建筑思考的桎梏<br>从全世界范围征集的数百份作品中选出的佼佼者</div>
                <div class="content">
                  <p>互联网、人工智能、区块链、虚拟现实…似乎每个概念都和建筑相关，但又都在其庞大的投资和巨量的协作前无法撼动根基，仿佛建筑行业就应该是那个在时代中跑得最慢的一个，又仿佛慢半拍的建筑已经足够满足人们的需要。</p>
                  <p>本书的作者们想挑战的，就是对于建筑思考的桎梏。作为遍布全球的中国青年设计师，他们在不同的方向上用作品讲述着对建筑未来的认知。这些作品，或探讨形式，或品味乡土，或触摸材料，或剖析社会，它们是从全世界范围征集的数百份作品中选出的佼佼者，作者们是试图讨论建筑未来，讨论建筑行业未来，讨论建筑与社会变化间关系的思想先锋。</p>
                </div>
              </div>
              <div class="book-section">
                <div class="book-title">康奈尔建筑系主任和纽约知名设计师联名推荐</div>
                <div class="content">
                  <p>康奈尔建筑系主任和纽约知名设计师联名推荐，提升设计和欣赏水平，了解建筑景观设计新风潮，从看世界名校名所设计师们的最新作品开始。20个完整的设计，代表了中国年轻海外设计师的较高水平，这些设计在不同尺度，不同风格，考虑并试图解决了不同的问题。从高清大图到中英文设计思路解析，让你了解名校名所设计师的思路和表现手法，让你知道设计用中文怎么叙述，用英文如何描述，让你知道世界各地的华人大牛们在世界名校名所中，有什么不同的表现和担当。</p>
                </div>
              </div>
            </div>
          </div>
          <button class="buy-book" @click="buyBook">去购买<icon icon-class="navigation-arrow"></icon></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .achievement-wrapper{
    height: calc(~"100vh - 87px");
    overflow: hidden;
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
    width: 100%;
    .nav-box{
      position: fixed;
      top: 87px;
      left: 0;
      width: 100%;
      height: 56px;
      display: flex;
      background: #F8F8F8;
      display: flex;
      justify-content: space-between;
      z-index: 10;
      padding: 0 20px;
      .nav-item{
        margin-top: 20px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
        transition: all .2s;
        &.active{
          color: #333;
          font-weight: bold;
        }
      }
      .active-line{
        position: absolute;
        top: calc(~"100% - 15px");
        width: 24px;
        height: 3px;
        background-color: @cano;
        border-radius: 3px;
        transition: all .3s ease;
        transform: translateX(-50%);
      }
    }
    .achievement-main{
      margin-top: 56px;
      flex: 1;
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #FFF;
      height: 0;
      .list-wrapper{
        height: 100%;
        overflow-y: auto;
        .exp-list{
          padding: 0 8px 0 12px;
          .exp-item{
            padding: 16px 0;
            border-bottom: 1px solid #EEE;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .info{
              min-width: 0;
              padding-right: 10px;
              .title{
                font-size: 15px;
                line-height: 21px;
                color: #333;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
              .student{
                margin-top: 8px;
                display: flex;
                align-items: center;
                .logo{
                  width: 36px;
                  height: 36px;
                  overflow: hidden;
                  img{
                    width: 100%;
                    height: 100%;
                  }
                }
                .student-info{
                  padding-left: 8px;
                  font-size: 12px;
                  line-height: 12px;
                  color: #666;
                  .school{
                    margin-top: 8px;
                  }
                }
              }
            }
            .cover{
              flex-shrink: 0;
              width: 114px;
              height: 84px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 3px;
              img{
                width: 100%;
              }
            }
          }
        }
        .studio-list{
          padding: 0 8px 0 12px;
          .studio-item{
            padding: 16px 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            border-bottom: 1px solid #EEE;
            .info{
              min-width: 0;
              padding-right: 10px;
              .title{
                font-size: 15px;
                line-height: 21px;
                color: #333;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
              .sub-info{
                margin-top: 12px;
                font-size: 12px;
                line-height: 12px;
                color: #999;
                &:last-child{
                  margin-top: 8px;
                }
              }
            }
            .cover{
              flex-shrink: 0;
              width: 114px;
              height: 84px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 3px;
              img{
                width: 100%;
              }
            }
          }
        }
        .graduate-list{
          padding: 0 8px 0 12px;
          .graduate-item{
            padding: 16px 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            border-bottom: 1px solid #EEE;
            .student{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              padding-right: 12px;
              .school-logo{
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              .info{
                padding-left: 12px;
                min-width: 0;
                .name{
                  font-size: 14px;
                  line-height: 14px;
                  color: #333;
                  font-weight: 600;
                }
                .offer-school{
                  font-size: 14px;
                  line-height: 14px;
                  color: #333;
                  margin-top: 12px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .other-school{
                  font-size: 12px;
                  line-height: 18px;
                  color: #666;
                  margin-top: 8px;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  display:-webkit-box;
                  -webkit-box-orient:vertical;
                  -webkit-line-clamp:2;
                }
              }
            }
            .cover{
              flex-shrink: 0;
              width: 114px;
              height: 84px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 3px;
              overflow: hidden;
              img{
                width: 100%;
              }
            }
          }
        }
        .no-more {
          height: 60px;
          width: 100%;
          line-height: 60px;
          text-align: center;
          font-size: 14px;
          color: #888888;
        }
      }
      .book-wrapper{
        height: 100%;
        overflow-y: auto;
        .book-container{
          padding-bottom: 94px;
          .book-banner{
            width: 100%;
            height: 2.12rem;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .book-section{
            margin-top: 24px;
            padding: 0 20px;
            position: relative;
            .book-title{
              position: relative;
              padding-top: 12px;
              font-size: 16px;
              line-height: 24px;
              color: #333;
              font-weight: 600;
              &::after{
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 32px;
                height: 4px;
                border-radius: 1px;
                background: #A3CFE3;
              }
            }
            .content{
              margin-top: 12px;
              font-size: 14px;
              line-height: 24px;
              color: #666;
              p:not(:first-child) {
                margin-top: 8px;
              }
            }
          }
        }
      }
      .buy-book{
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        width: 3.36rem;
        height: 42px;
        box-shadow: 0px 4px 10px 0px rgba(77, 162, 199, 0.3);
        background: @cano;
        border: 0;
        border-radius: 42px;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        svg{
          font-size: 12px;
          margin-left: 8px;
          font-weight: bold;
        }
      }
    }
  }
</style>

<script>
  import Swiper, { Navigation, Pagination } from 'swiper'
  import ScrollView from '@/components/Common/scrollView.vue'
  export default {
    data() {
      return {
        currentPage: 0,
        // tab-item的下划线位置
        navArr: [12.5, 37.5, 62.5, 87.5],
        navLeft: 0,
        courseSwiper: null,
        listSwiper: null,
        // 经验弹
        expArticleList: [],
        // 设计室成果
        studioList: [],
        // 优秀毕业生
        graduateList: [],
      }
    },
    components: {
      ScrollView
    },
    created() {
      this.$store.commit('setActiveMenu', 'achievement');
      this.getExpArticleList();
    },
    mounted() {
      Swiper.use([Navigation, Pagination]);
      setTimeout(() => {
        this.getNavLinePos(0);
      }, 0)
      let _this = this;
      this.listSwiper = new Swiper('#listSwiper', {
        noSwiping: true,
        noSwipingSelector: '.on-swipeing',
        on: {
          slideChange() {
            _this.currentPage = this.activeIndex;
            _this.getNavLinePos(this.activeIndex);
            _this.pageDataLoad();
          }
        }
      });
    },
    methods: {
      getNavLinePos(index) {
        let navs = document.querySelectorAll('.nav-item');
        let currentNav = navs[index];
        this.navLeft = currentNav.offsetLeft + (currentNav.clientWidth / 2);
      },
      switchPage(index) {
        this.currentPage = index;
        this.getNavLinePos(index);
        this.listSwiper.slideTo(index);
      },
      pageDataLoad() {
        if(this.currentPage == 1 && this.studioList.length == 0) {
          this.getStudio();
        }else if(this.currentPage == 2 && this.graduateList.length == 0) {
          this.getGraduate();
        }
      },
      // 获取经验弹数据
      getExpArticleList() {
        this.$root.post('/Star/get_student_article_list', {
          year: '',
          major: 0,
          tag: 0,
          search: '',
        }).then(data => {
          console.log(data);
          this.expArticleList = data || [];
        })
      },
      // 获取设计室成果
      getStudio() {
        this.$root.post('/Star/get_studio_article', {
          major: 0,
          search: '',
        }).then(data => {
          console.log(data);
          this.studioList = data.info || [];
        })
      },
      // 获取优秀毕业生
      getGraduate() {
        this.$root.post('/Star/get_newstar_list', {
          year: '',
          major: '',
          search: '',
        }).then(data => {
          data.forEach(item => {
            if(item.offer && item.offer.length > 0) {
              item.offer.splice(0, 1);
              item.offerString = item.offer.join(',');
            }
          })
          console.log(data);
          this.graduateList = data || [];
        })
      },
      // 详情页
      toDetail(type, id) {
        switch(type) {
          case 1: {
            this.$router.push({name: 'ExpDetail', params: {id: id}});
          };break;
          case 2: {
            this.$router.push({name: 'ArticleDetail', params: {id: id}});
          };break;
          case 3: {
            this.$router.push({name: 'GraduateDetail', params: {id: id}});
          };break;
        }
      },
      buyBook() {
        this.$router.push('/book');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Star/index.vue